import { makeStyles } from '@material-ui/core';
import React from 'react';
import ScrollableContent from 'src/components/ScrollableContent';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
    content: {
        position: 'fixed',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        flexGrow: 1,
        maxWidth: '100%',
        overflowX: 'hidden',
        height: 'calc(100% - env(safe-area-inset-bottom))'
    }
}));

const MainLayout = ({ children }) => {
    const classes = useStyles();

    return (
        <div className={classes.content}>
            <ScrollableContent style={{ minHeight: '100%', display: 'flex', flexDirection: 'column' }}>
                {children}
            </ScrollableContent>
        </div>
    );
};

MainLayout.propTypes = {
    children: PropTypes.any
};

export default MainLayout;